import { Controller } from "@hotwired/stimulus"
import { CurrencyHelper } from "~/helpers/currency_helper"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to remove lead(s) from a leads list.
export default class extends Controller {
  static get targets() {
    return ["dialogText"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      listName: { type: String, default: "" },
      numberOfLeads: { type: Number, default: 0 },
      selectedLeadIds: { type: Array, default: [] },
    }
  }

  submit() {
    let leadIds = this.selectedLeadIdsValue
    let formToSubmit = TempFormHelper.create("/lead/bulk", "put", (form) => {
      TempFormHelper.addHiddenInput(form, "to_leads_list_id", "0")
      TempFormHelper.addHiddenInput(form, "from_leads_list_id", this.filtersValue["leads_list_id"])
      TempFormHelper.addHiddenInput(form, "remove_from_list", "true")

      if (leadIds.length > 0) {
        leadIds.forEach(leadId => { TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId) })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(arrayValue => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, arrayValue)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    })

    formToSubmit.dataset.confirmDialogId = "confirm-remove-from-leads-list"
    formToSubmit.dataset.turboConfirm = i18n.t("js.back.lead_actions.remove_from_list")
    formToSubmit.requestSubmit()
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    const allSelected = event.detail.allSelected

    if (allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }

    const numberOfLeads = allSelected ? this.numberOfLeadsValue : this.selectedLeadIdsValue.length
    const leadName = numberOfLeads === 1 ? event.detail.dataSets[0]?.leadName : false
    if (leadName) {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.lead_actions.remove_from_list.description_with_name_html", { lead_name: leadName, list_name: this.listNameValue })
    } else {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.lead_actions.remove_from_list.description_with_number_html", { lead_name: numberOfLeads, count: numberOfLeads, number_of_leads: CurrencyHelper.numberWithDelimiter(numberOfLeads), list_name: this.listNameValue })
    }
  }
}
